import React, { useState, useEffect } from "react";
import axios from "axios";
import { Link } from "react-router-dom";
import { DataGrid } from "@mui/x-data-grid";
import Swal from "sweetalert2";
import SearchOutlinedIcon from "@mui/icons-material/SearchOutlined";
import RemoveRedEyeOutlinedIcon from "@mui/icons-material/RemoveRedEyeOutlined";
import EditOutlinedIcon from "@mui/icons-material/EditOutlined";
import DeleteOutlineIcon from "@mui/icons-material/DeleteOutline";
import Loader from "../../../../components/Loader/Loader";
import "../../../../components/common/css/datatable.scss";

const Partnerlist = () => {
  const [query, setQuery] = useState("");
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  
  const deleteFunction = (id) => {
    const token = localStorage.getItem("accessToken");
    Swal.fire({
      title: "Are you sure?",
      text: "You won't be able to revert this!",
      icon: "warning",
      showCancelButton: true,
      showCloseButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, delete it!",
    }).then((result) => {
      if (result.isConfirmed) {
        setLoading(true);
        var config = {
          method: "delete",
          url: process.env.REACT_APP_API + "delete-our-partners",
          headers: {
            "x-access-token": token,
          },
          data: {
            id: id,
          },
        };
        axios(config)
          .then(function (res) {
            if (res.status == 200) {
              Swal.fire("Deleted!", "Your file has been deleted.", "success");
              fetchcategorydata();
              setLoading(false);
            }
          })
          .catch(function (error) {
            setLoading(false);
            console.log(error);
          });
      } else if (result.dismiss === Swal.DismissReason.cancel) {
        setLoading(false);
        Swal.fire("Cancelled", "Your data is safe", "error");
      }
    });
  };

  const search = (data) => {
    return data?.filter(
      (item) =>
        item?.title?.toLowerCase()?.includes(query) ||
        item?.about_partners?.toLowerCase()?.includes(query) ||
        item?.description?.toLowerCase()?.includes(query)
    );
  };

  const fetchcategorydata = () => {
    setLoading(true);
    var config = {
      method: "get",
      url: process.env.REACT_APP_API + "our-partners",
    };

    axios(config)
      .then(function (response) {
        setData(response.data.data);
        setLoading(false);
      })
      .catch(function (error) {
        setLoading(false);
      });
  };

  useEffect(() => {
    fetchcategorydata();
  }, []);

  const actionColumn = [
    {
      field: "action",
      headerName: "Action",
      width: 200,
      renderCell: (params) => {
        return (
          <div className="cellAction">
            <Link
              to={`/our-partners/${params.row.id} `}
              style={{ textDecoration: "none" }}
            >
              <div className="viewButton">
                <RemoveRedEyeOutlinedIcon />
              </div>
            </Link>
            <Link
              to={`/our-partners/edit/${params.row.id} `}
              style={{ textDecoration: "none" }}
            >
              <div className="editButton">
                <EditOutlinedIcon />
              </div>
            </Link>
            <div
              className="deleteButton"
              onClick={() => deleteFunction(params.row.id)}
            >
              <DeleteOutlineIcon />
            </div>
          </div>
        );
      },
    },
  ];

  const userColumns = [
    { field: "id", headerName: "ID", width: 70 },
    {
      field: "profile_pic",
      headerName: "Profile",
      width: 100,
      renderCell: (params) => (
        <div className="cellWrapper">
          <div className="profilePic">
            <img src={params?.row?.profile_pic} className="image" />
          </div>
        </div>
      ),
    },
    {
      field: "title",
      headerName: "Title",
      width: 200,
    },
    {
      field: "about_partners",
      headerName: "About Partner",
      width: 200,
    },
    {
      field: "description",
      headerName: "Description",
      width: 200,
    },
  ];

  return (
    <div className="datatable">
      <Loader isLoading={loading} />
      <div className="datatableTitle">
        <div className="tablesearch">
          <input
            type="text"
            placeholder="Search..."
            onChange={(e) => setQuery(e.target.value)}
          />
          <SearchOutlinedIcon className="sarchicon" />
        </div>
        <h5 style={{ marginLeft: "-10%" }}>Our Partners</h5>
        <Link to="/our-partners/add-partner" className="link">
          Add New
        </Link>
      </div>
      
      <DataGrid
        className="datagrid"
        rows={search(data)}
        columns={userColumns.concat(actionColumn)}
        pageSize={9}
        rowsPerPageOptions={[9]}
      />
    </div>
  );
};

export default Partnerlist;
